export function fmtMonth(ym) {
  if (!ym) return '';
  const s = String(ym);
  const y = s.slice(0, 4);
  const m = parseInt(s.slice(4, 6), 10);
  const names = ['','Jan','Feb','Mar','Apr','Maj','Jun','Jul','Aug','Sep','Okt','Nov','Dec'];
  return names[m] + ' ' + y;
}
